import classnames from 'classnames/bind'

// Libs
import useMultiDropdownValues from '@/hooks/useMultiDropdownValues'

// Components
import CategoryTabs from './CategoryTabs'
import MallList from '@/components/shared/MallList'

// Constants
import { MULTI_DROPDOWN_KEYS } from '@/types/system-dropdown/multi'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type ProductListProps = {
  categoryListData: any
  gtmItemEventParams: {
    itemListName: string
    itemListId?: string
  }
}

const ProductList = ({ categoryListData, gtmItemEventParams }: ProductListProps) => {
  const { shopHomeFeaturedList } = useMultiDropdownValues({ keys: MULTI_DROPDOWN_KEYS.SHOP_HOME_FEATURED })

  return (
    <div>
      <CategoryTabs shopHomeFeaturedList={shopHomeFeaturedList} />

      <MallList className={cx('mall-list')} categoryListData={categoryListData} gtmItemEventParams={gtmItemEventParams} />
    </div>
  )
}

export default ProductList
